import { WebAnalysisGeographyContainer } from "app/pages/website-analysis/geography/WebAnalysisGeographyContainer";

export const WebAnalysisGeographyRoot = () => {
    return <WebAnalysisGeographyContainer />;
};
